import { BrowserRouter as Router } from "react-router-dom";
import AuthRoutePath from "./AuthRoutePath";
import PublicRoutePath from "./PublicRoutePath";

const AppRouter: React.FC = () => {
  return (
    <Router>
      <AuthRoutePath />
      <PublicRoutePath />
    </Router>
  );
};

export default AppRouter;
